namespace Solovis.Reports.ReportHelpers {

    export class StatsColumnHelper {

        /**
         * This is a generic helper go combine annualized and cumulative return columns into one that always returns the annualized returns
         * for time periods greater than one year.
         * @param annualizedGetter
         * @param cumulativeGetter
         * @param baseColTemplate
         */
        public static createAnnualizedCumulativeColumnTemplate(annualizedGetter, cumulativeGetter, baseColTemplate, cellIntervalRangeGetter?) {

            let columnTemplate: any = {};

            let returnDataGetter = function (row) {
                let annReturn;
                let cumReturn;

                if (row._backingRow) {
                    row = row._backingRow;
                }

                let intervalRange: any;
                if (cellIntervalRangeGetter) {
                    intervalRange = cellIntervalRangeGetter(row, columnTemplate);                    
                }

                if (typeof annualizedGetter === "string") {
                    annReturn = Solovis.resolveObject(annualizedGetter, row);
                }
                else {
                    annReturn = annualizedGetter(row, columnTemplate);
                }

                if (typeof cumulativeGetter === "string") {
                    cumReturn = Solovis.resolveObject(cumulativeGetter, row);
                }
                else {
                    cumReturn = cumulativeGetter(row, columnTemplate);
                }

                let showAnnualized = false;
                let showCumulative = false;
                
                if (intervalRange) {                    
                    // See #15416 for discussion of which return gets shown in hybrid column.

                    // Use the information about interval range size and data coverage to determine what to show.
                    if (intervalRange.isSinceInception) {
                        if (Solovis.isNotNull(intervalRange.dataDays)) {
                            // In this case, we will use dataDays to determine whether to show cumulative or annualized. We
                            // will always show cumulative if data covered 366 days or less.
                            if (intervalRange.dataDays < 366) {
                                showCumulative = true;
                            }
                            else {
                                showAnnualized = true;
                            }
                        }
                    }
                    else {
                        if (intervalRange.intervalDays >= 366) {
                            // We always show annualized returns for intervals where range is more than 366 days (if they aren't Since Inception).
                            showAnnualized = true;
                        }
                        else {
                            // Interval range is 366 days or less here.

                            // For the specific case of 365 or 366 days for 1yr or since date columns, we have the peculiar behavior to 
                            // only show cumulative column if the line item has data on interval start.
                            if (intervalRange.isSinceStyleInterval && intervalRange.intervalDays >= 365) {
                                if (intervalRange.hasDataOnIntervalStart) {
                                    showCumulative = true;
                                }
                            }
                            else {
                                // Interval range is 364 days or less, so always only show cumulative.
                                showCumulative = true;
                            }
                        }
                    }
                }
                else if (Solovis.isNotNull(cumReturn) && Solovis.isNotNull(annReturn)) {
                    // Use the information about relative size of cumulative and annualized return to decide which is larger.
                    if (cumReturn > 0) {
                        if (cumReturn >= annReturn) {
                            showAnnualized = true;
                        }
                        else {
                            showCumulative = true;
                        }
                    }
                    else if (cumReturn < 0) {
                        if (cumReturn <= annReturn) {
                            showAnnualized = true;
                        }
                        else {
                            showCumulative = true;
                        }
                    }
                    else {
                        showAnnualized = true;
                    }
                }                

                if (showAnnualized) {
                    return {
                        value: annReturn,
                        isCumulative: false
                    };
                }
                else if (showCumulative) {
                    return {
                        value: cumReturn,
                        isCumulative: true
                    };
                }
                else {
                    return {
                        value: null,
                        isCumulative: false
                    };
                }
            };

            columnTemplate.field = function (row) {
                var data = returnDataGetter(row);
                if (data) {
                    return data.value;
                }
            };

            columnTemplate.dataType = "percentage";
            columnTemplate.width = 130;

            columnTemplate.htmlFormatter = function (cellValue, valueContext) {
                var value = returnDataGetter(valueContext.row);
                if (value) {
                    var defaultElement = valueContext.defaultFormatter(value.value, valueContext);

                    if (!value.isCumulative) {
                        return defaultElement;
                    }
                    else {
                        var div = $("<div>");
                        $("<span>").text("cum: ").css("color", "#bbb").appendTo(div);
                        div.append(defaultElement);
                        return div;
                    }
                }
            };

            if (baseColTemplate) {
                for (var key in baseColTemplate) {
                    columnTemplate[key] = baseColTemplate[key];
                }
            }

            return columnTemplate;
        }


        public static createActiveReturnColumnTemplate(primaryGetter, benchmarkGetter, baseColTemplate) {

            let columnTemplate: any = {};

            let returnDataGetter = function (row) {
                let primaryReturn;
                let benchmarkReturn;

                if (row._backingRow) {
                    row = row._backingRow;
                }
                
                if (typeof primaryGetter === "string") {
                    primaryReturn = Solovis.resolveObject(primaryGetter, row);
                }
                else {                    
                    primaryReturn = primaryGetter(row, columnTemplate);
                }

                if (typeof benchmarkGetter === "string") {
                    benchmarkReturn = Solovis.resolveObject(benchmarkGetter, row);
                }
                else {
                    benchmarkReturn = benchmarkGetter(row, columnTemplate);
                }

                if (Solovis.isNotNull(benchmarkReturn) && Solovis.isNotNull(primaryReturn)) {
                    let delta = primaryReturn - benchmarkReturn;
                    return delta;
                }
                else {
                    return null;
                }
            };

            columnTemplate.field = function (row) {                
                var data = returnDataGetter(row);
                if (data) {
                    return data;
                }
            };

            columnTemplate.dataType = "percentage";
         
            if (baseColTemplate) {
                for (var key in baseColTemplate) {
                    columnTemplate[key] = baseColTemplate[key];
                }
            }

            return columnTemplate;
        }

    }

}